import {Logger} from 'tslog';

export default new Logger({
    name: 'scratch-gui'
});
